import { styled } from 'styled-components';

// Heading for items list
export const SectionHeading = styled.h3`
  background-color: var(--color-grey-lighter);
  color: var(--color-blue-dark);
  font-size: var(--font-sm);
  font-weight: var(--font-semibold);
  margin-block: var(--spacing-small);
  padding-block: var(--spacing-tiny);
  padding-inline: var(--spacing-medium);
  text-transform: uppercase;
`;
